export default __webpack_public_path__ + "static/customize-angular-slideable-02a63ed637d4de3595d758a03e5aa0c2.png";